<template>
  <div class="card-body">
    <!-- Leasing / Insurance -->
    <div class="form-row align-items-baseline">
      <div class="col-12">
        <div class="alert alert-info">
          <i class="fas fa-info-circle"></i>
          <span>{{ trans('To protect your data, the following information is not publicly available') }}</span>
        </div>
      </div>
    </div>

    <!-- Anitheft -->
    <div class="form-row align-items-baseline">
      <div class="form-group col-lg-4">
        <!-- NFC -->
        <label :for="`${id}-nfc`" class="font-weight-bold text-dark text-2">
          {{ trans('NFC-ID-Number') }}
        </label>
        <input :id="`${id}-nfc`"
               type="text"
               placeholder="ABC"
               v-model="nfc_id"
               class="nfc-id-field form-control cursor-text" :class="{ error: hasError('nfc_id') }">
        <label class="error" v-if="hasError('nfc_id')">{{ errors['nfc_id'][0] }}</label>
      </div>

      <div class="form-group col-lg-4">
        <!-- Tracker -->
        <label :for="`${id}-tracker`" class="font-weight-bold text-dark text-2">
          {{ trans('Tracker') }}
        </label>
        <input :id="`${id}-tracker`"
               type="text"
               placeholder="XYZ"
               v-model="tracker_id"
               class="form-control" :class="{ error: hasError('tracker_id') }">
        <label class="error" v-if="hasError('tracker_id')">{{ errors['tracker_id'][0] }}</label>
      </div>

      <div class="form-group col-lg-4">
        <label :for="`${id}-microdots-pin`" class="font-weight-bold text-dark text-2">
          {{ trans('MICRODOTS-PIN') }}
        </label>
        <input
          :id="`${id}-microdots-pin`"
          type="text"
          placeholder=""
          v-model="microdots_pin"
          class="form-control cursor-text"
          :class="{ error: hasError('microdots_pin') }"
        >
        <label class="error" v-if="hasError('microdots_pin')">{{ errors['microdots_pin'][0] }}</label>
      </div>
    </div>

    <div class="form-row align-items-baseline">
      <div class="form-group col-lg-4">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" :id="`${id}-has-alarm`"
                 @change="$emit('update:hasAlarm', $event.target.checked)"
                 :checked="hasAlarm"
                 :class="{ error: hasError('has_alarm')}">
          <label class="custom-control-label" :for="`${id}-has-alarm`">{{ trans('Has Alarm') }}</label>
        </div>
      </div>

      <div class="form-group col-lg-4">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" :id="`${id}-has-immobilizer`"
                 @change="$emit('update:hasImmobilizer', $event.target.checked)"
                 :checked="hasImmobilizer"
                 :class="{ error: hasError('has_immobilizer')}">
          <label class="custom-control-label" :for="`${id}-has-immobilizer`">{{ trans('Has Immobilizer') }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "VehicleInsurance",

    props: {
      trackerId: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      microdotsPin: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      nfcId: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      errors: {
        validator: prop => typeof prop === 'object' || prop === null,
        required: true,
        default: {},
      },
      hasAlarm: {
        type: Boolean,
        default: false,
      },
      hasImmobilizer: {
        type: Boolean,
        default: false,
      },
    },

    watch: {
      tracker_id(val) {
        this.$emit('update:trackerId', val)
      },

      microdots_pin(val) {
        this.$emit('update:microdotsPin', val);
      },

      nfc_id(val) {
        this.$emit('update:nfcId', val)
      },
    },

    data() {
      return {
        id: null,
        tracker_id: this.trackerId,
        nfc_id: this.nfcId,
        microdots_pin: this.microdotsPin,
      }
    },

    mounted() {
      this.id = `c${this._uid}`;
    },

    methods: {
      hasError(fieldName) {
        return this.errors.hasOwnProperty(fieldName);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .cursor-text {
    cursor: text !important;
  }
</style>
